// extracted by mini-css-extract-plugin
export default {"container":"DetailLine_container__1rYjB","name":"DetailLine_name__jNW0-","value":"DetailLine_value__+uPKe"};